module.exports = __webpack_public_path__ + "img/shouye-jishujingliren-png.6ac230cb.svg";